<template>
  <v-container width="1200px">
    <v-alert v-if="!authorized" type="error" class="mt-4">
      You do not have permission to access the Admin Payroll view.
    </v-alert>

    <AdminPayrollView
      v-else
      :user="user"
      :settings="payrollSettings"
      :validationRules="validationRules"
      @updateSettings="handleUpdateSettings"
      @updateRules="handleUpdateRules"
    />

    <TimeDoctor2ConnectView v-if="authorized" />

    <ClassicTimesheetView v-if="authorized" />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AdminPayrollView from "./components/AdminPayrollView.vue";
import ClassicTimesheetView from "./components/ClassicTimesheetView.vue";
import TimeDoctor2ConnectView from "./components/TimeDoctor2ConnectView.vue";

export default {
  name: "PayrollAdminPage",
  components: {
    AdminPayrollView,
    ClassicTimesheetView,
    TimeDoctor2ConnectView,
  },
  data() {
    return {
      authorized: false,
      payrollSettings: {
        payrollCutoffDay: 15,
        paymentDay: 25,
        defaultCurrency: 'USD',
        autoApproveThreshold: 0,
        requireCOR: true,
        requireAcknowledgementReceipt: true,
        notifyOnSubmission: true,
        notifyOnApproval: true,
      },
      validationRules: [
        {
          id: 1,
          name: 'Hours Variance Check',
          description: 'Flag submissions where hours differ from Time Doctor by more than threshold',
          value: 5,
          unit: 'percent',
          enabled: true,
        },
        {
          id: 2,
          name: 'Rate Discrepancy Check',
          description: 'Flag submissions where invoice amount differs from calculated amount',
          value: 2,
          unit: 'percent',
          enabled: true,
        },
        {
          id: 3,
          name: 'COR Expiry Warning',
          description: 'Warn when Certificate of Registration is about to expire',
          value: 30,
          unit: 'days',
          enabled: true,
        },
        {
          id: 4,
          name: 'Maximum Hours Threshold',
          description: 'Flag submissions exceeding maximum hours',
          value: 100,
          unit: 'hours',
          enabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/get_user",
    }),
    isAdminOrManager() {
      const adminEmails = ['dillongunn@gmail.com', 'daniza@stagit.ie', 'accounts.nalie@stagit.ie', 'accounts@profitabletradesmen.com', 'mariatheresa.pt@gmail.com'];
      // Daniza (id 122) matched by id too, in case email isn't on the auth user
      return Number(this.user?.id) === 122 || adminEmails.includes(this.user?.email?.toLowerCase());
    },
  },
  mounted() {
    if (!this.isAdminOrManager) {
      this.authorized = false;
      this.$toast.error('You do not have permission to access this page');
      return;
    }
    this.authorized = true;
  },
  methods: {
    handleUpdateSettings(settings) {
      this.payrollSettings = { ...settings };
      this.$toast.success('Payroll settings saved');
      // TODO: Persist to backend when API is available
    },

    handleUpdateRules(rules) {
      this.validationRules = [...rules];
      this.$toast.success('Validation rules saved');
      // TODO: Persist to backend when API is available
    },
  },
};
</script>

<style scoped>
</style>
